import React from 'react';
import { Target, Eye, Heart } from 'lucide-react';
import { aboutContent } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="about-page">
      <SEO 
        title="About Us"
        description="Savanna Skies Ltd is an African-owned aircraft leasing company founded in 2025. Learn about our mission to drive African aviation growth through flexible financing solutions."
        keywords="about Savanna Skies, African aviation company, aircraft leasing Africa, aviation finance company"
        canonicalUrl="/about"
      />
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">About Savanna Skies</h1>
          <p className="page-subtitle">
            African-owned. Globally competitive. Built for growth.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision-section">
        <div className="mission-vision-grid">
          <Card className="mission-card">
            <CardContent className="mission-content">
              <div className="mission-icon-wrapper">
                <Target size={40} className="mission-icon" />
              </div>
              <h2 className="mission-title">Our Mission</h2>
              <p className="mission-text">{aboutContent.mission}</p>
            </CardContent>
          </Card>

          <Card className="vision-card">
            <CardContent className="vision-content">
              <div className="vision-icon-wrapper">
                <Eye size={40} className="vision-icon" />
              </div>
              <h2 className="vision-title">Our Vision</h2>
              <p className="vision-text">{aboutContent.vision}</p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Company Story */}
      <section className="story-section">
        <div className="story-content">
          <h2 className="section-title">Our Story</h2>
          <div className="story-text">
            <p className="story-paragraph">
              Founded in 2025, Savanna Skies Ltd emerged from a vision to transform African aviation through accessible, innovative aircraft leasing and financing solutions. As an African-owned and operated lessor, we understand the unique opportunities and challenges facing airlines across the continent.
            </p>
            <p className="story-paragraph">
              Drawing inspiration from global leaders like Aircastle and AerCap, Savanna Skies combines international best practices with deep regional expertise. We're building a portfolio of modern, fuel-efficient aircraft that enables airlines to expand connectivity, serve underserved markets, and compete on the global stage.
            </p>
            <p className="story-paragraph">
              Our commitment goes beyond transactions. We partner with airlines to structure flexible financing that supports sustainable growth, operational efficiency, and long-term success. Every lease, every aircraft, every relationship is built on our foundational belief: African aviation has limitless potential, and we're here to help unlock it.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="values-header">
          <h2 className="section-title">Our Values</h2>
          <p className="section-subtitle">The principles that guide everything we do</p>
        </div>
        <div className="values-grid">
          {aboutContent.values.map((value, index) => (
            <Card key={index} className="value-card">
              <CardContent className="value-content">
                <div className="value-icon-wrapper">
                  <Heart size={28} className="value-icon" />
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* Commitment Section */}
      <section className="commitment-section">
        <div className="commitment-content">
          <h2 className="commitment-title">Commitment to Excellence</h2>
          <p className="commitment-text">
            At Savanna Skies, excellence isn't just about having modern aircraft or competitive rates. It's about understanding the intricacies of African markets, anticipating our partners' needs, and delivering solutions that create lasting value. From lease structuring to ongoing support, we're committed to being the partner of choice for airlines ready to soar.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;